import Vue from 'vue'
import Router from 'vue-router'
import Users from '@/components/users/Users'
import EditUser from '@/components/users/EditUser'
import Managers from '@/components/managers/Managers'
import Occupations from '@/components/occupations/Occupations'
import Dashboard from '@/components/dashboard/Dashboard'
import Services from '@/components/services/Services'
import TimeCodes from '@/components/timeCodes/TimeCodes'
import NewTimeCode from '@/components/timeCodes/NewTimeCode'
import EditTimeCode from '@/components/timeCodes/EditTimeCode'
import SigninForm from '@/components/SignInForm'
import SignUpForm from '@/components/SignUpForm'
import ForgotPassword from '@/components/recoverPassword/ForgotPasswordForm'
import ResetPassword from '@/components/recoverPassword/ResetPasswordForm'
import NewManager from '@/components/managers/NewManager'
import NewUser from '@/components/users/NewUser'
import store from '@/store';
import Offers from '@/components/offers/Offers'
import Offer from '@/components/offers/Offer'
import OfferCandidateDetail from '@/components/offers/OfferCandidateDetail'
import OfferSendToStaff from '@/components/offers/OfferSendToStaff'
import OfferContract from '@/components/offers/OfferContract'
import NotDisturbMode from '@/components/users/NotDisturbMode'
import RequestHistories from '@/components/offers/RequestHistories'
import UpdateInformation from '@/components/UpdateInformation'
import CandidateEntities from '@/components/entities/CandidateEntities'
import CandidateJoinEntities from '@/components/entities/CandidateJoinEntities'
import ManagerEntities from '@/components/entities/ManagerEntities'
import ContractPreview from '@/components/contracts/ContractPreview'
import Contract from '@/components/contracts/Contract'
import loginRouters from '@/settings/loginRouters'
import EditProfile from '@/components/users/EditProfile'
import NewOffer from '@/components/offers/NewOffer'
import EditOffer from '@/components/offers/EditOffer'
import EditOfferContract from '@/components/offers/EditOfferContract'
import Stats from '@/components/stats/Index'
import UnavailabilityCalendar from '@/components/unavailabilityCalendars/UnavailabilityCalendar'
import CandidatePlanning from '@/components/users/CandidatePlanning'
import SignUpConfirmationPage from '@/components/SignUpConfirmationPage'
import DashboardPage from '@/components/DashboardPage'
import UserKit from '@/components/userKit/UserKit'
import sendEventToPiano from '@/helpers/at_internet/send_event_to_piano'

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}

const withPrefix = (prefix, routes) =>
  routes.map( (route) => {
      route.path = prefix + route.path;
      return route;
  });

export const router =  new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Dashboard', component: DashboardPage, meta: { smartTag: { name: 'Dashbord' } } },
    { path: '/offers', name: 'Offers', component: Offers, meta: { smartTag: { name: 'Offers' } } },
    { path: '/request_histories', name: 'RequestHistories', component: RequestHistories, meta: { smartTag: { name: 'RequestHistories' } } },
    { path: '/users/password/new', name: 'ForgotPassword', component: ForgotPassword },
    { path: '/users/change-password', name: 'ResetPassword', component: ResetPassword },
    { path: '/users/set-password', name: 'SetPassword', component: ResetPassword },
    { path: '/users/update_information', name: 'UpdateInformation', component: UpdateInformation },
    { path: '/users/signin', name: 'SignInForm', component: SigninForm },
    { path: '/users/signup/:entityCode?', name: 'SignUpForm', component: SignUpForm },
    { path: '/users/signup-confirmation', name: 'SignUpConfirmationPage', component: SignUpConfirmationPage },
    { path: '/offers/:id', name: 'OfferCandidateDetail', component: OfferCandidateDetail, meta: { smartTag: { name: 'OfferCandidateDetail' } } },
    { path: '/not-disturb-mode', name: 'NotDisturbMode', component: NotDisturbMode },
    { path: '/unavailability-calendar', name: 'UnavailabilityCalendar', component: UnavailabilityCalendar, meta: { smartTag: { name: 'UnavailabilityCalendar' } } },
    { path: '/my-entities', name: 'CandidateEntities', component: CandidateEntities, meta: { smartTag: { name: 'CandidateEntities' } } },
    { path: '/join-entity', name: 'CandidateJoinEntities', component: CandidateJoinEntities, meta: { smartTag: { name: 'CandidateJoinEntities' } } },
    { path: '/my-manager-entities', name: 'ManagerEntities', component: ManagerEntities, meta: { smartTag: { name: 'ManagerEntities' } } },
    ...withPrefix('/admin',
      [
        { path: '/occupations', name: 'Occupations', component: Occupations, meta: { smartTag: { name: 'Occupations' } } },
        { path: '/users', name: 'Users', component: Users, meta: { smartTag: { name: 'Users' } } },
        { path: '/entities/:entity_id/users/new', name: 'NewUser', component: NewUser, meta: { smartTag: { name: 'NewUser' } } },
        { path: '/entities/:entity_id/users/:user_id/edit', name: 'EditUser', component: EditUser, meta: { smartTag: { name: 'EditUser' } } },
        { path: '/entities/:entity_id/users/:user_id/planning', name: 'CandidatePlanning', component: CandidatePlanning, meta: { smartTag: { name: 'CandidatePlanning' } } },
        { path: '/entities/managers', name: 'Managers', component: Managers, meta: { smartTag: { name: 'Managers' } } },
        { path: '/entities/:entity_id/managers/new', name: 'NewManager', component: NewManager, meta: { smartTag: { name: 'NewManager' } } },
        { path: '/entities/services', name: 'Services', component: Services, meta: { smartTag: { name: 'Services' } } },
        { path: '/entities/time_codes', name: 'TimeCodes', component: TimeCodes, meta: { smartTag: { name: 'TimeCodes' } } },
        { path: '/entities/:entity_id/time_codes/new', name: 'NewTimeCode', component: NewTimeCode, meta: { smartTag: { name: 'NewTimeCode' } } },
        { path: '/entities/:entity_id/time_codes/:time_code_id/edit', name: 'EditTimeCode', component: EditTimeCode, meta: { smartTag: { name: 'EditTimeCode' } } },
        { path: '/offers/new', name: 'NewOffer', component: NewOffer, meta: { smartTag: { name: 'NewOffer' } } },
        { path: '/entities/:entity_id/offers/:offer_id/edit', name: 'EditOffer', component: EditOffer, meta: { smartTag: { name: 'EditOffer' } } },
        { path: '/entities/:entity_id/offers/:offer_id/contracts-edit', name: 'EditOfferContract', component: EditOfferContract, meta: { smartTag: { name: 'EditOfferContract' } } },
        { path: '/offers/:id', name: 'AdminOffer', component: Offer, meta: { smartTag: { name: 'AdminOffer' } } },
        { path: '/offers/:id/send_offer_to_staff', name: 'OfferSendToStaff', component: OfferSendToStaff, meta: { smartTag: { name: 'OfferSendToStaff' } } },
        { path: '/offers/:id/contract/:contract_id', name: 'OfferContract', component: OfferContract, meta: { smartTag: { name: 'OfferContract' } } },
        {
          path: '/offers/:id/contract/:contract_id/preview',
          name: 'ContractPreview',
          meta: { smartTag: { name: 'ContractPreview' } },
          component: ContractPreview,
          props: (route) => {
            return { offerIds: route.query.offer_ids || [] }
          }
        },
        { path: '/stats', name: 'Stats', component: Stats, meta: { smartTag: { name: 'Stats' } } },
        { path: '/user_kit', name: 'UserKit', component: UserKit, meta: { smartTag: { name: 'UserKit' } } },
        { path: '/contracts/:id', name: 'Contract', component: Contract, meta: { smartTag: { name: 'Contract' } } },
      ]
    ),
    { path: '/edit_profile', name: 'EditProfile', component: EditProfile, meta: { smartTag: { name: 'EditProfile' } } },
    { path: '*', component: Dashboard, meta: { smartTag: { name: 'Dashbord' } } }
  ],
  scrollBehavior (to, from, savedPosition) {
    $("#main-content").scrollTop(0);
  }
})

router.beforeEach((to, from, next) => {
  var loggedIn = store.getters['auth/isLoggedIn']

  if(loggedIn) {
    $('body').removeClass("ie-body-login")
  } else {
    $('body').addClass("ie-body-login")
  }

  if (!loggedIn && !loginRouters.includes(to.name)){
    if (!process || process.env.NODE_ENV !== 'test') {
      next({ name: 'SignInForm', query: { redirect: to.path } })
    }
  } else if (loggedIn && (loginRouters.includes(to.name))){
    router.push('/')
  } else {
    store.dispatch('auth/setCheckShowPopupFeature', !loginRouters.includes(to.name));
    if (!process || process.env.NODE_ENV !== 'test') {
      next();
    }
  }
  store.dispatch('message/disable');
})

router.afterEach((to, from) => {
  if (to.meta.smartTag) {
    Vue.smartTag.sendPage(typeof to.meta.smartTag === 'function' ? to.meta.smartTag() : to.meta.smartTag)
  }
  let url = window.location.host + window.location.pathname;
  if (window.location.pathname === '/') {
    url = url.replace(/\/$/, '');
  }

  sendEventToPiano('page.display', { 'page': url, });
})



// WEBPACK FOOTER //
// ./src/router/index.js